export default __webpack_public_path__ + "static/media/closeIcon.97158a14.svg";